import{gql as o}from"@apollo/client";const t=o`
  mutation deleteBookmark($bookmarkId: Int, $contentPageId: Int) {
    bookmark {
      deleteBookmark: removeBookmark(input: { bookmarkId: $bookmarkId, contentPageId: $contentPageId })
    }
  }
`;export{t as DELETE_BOOKMARK_MUTATION};
//# sourceMappingURL=useDeleteBookmark.graphql.js.map
